export default {
  hero: {
    title: 'AllChinaBuy Spreadsheet — Find produkter, sælgere og købsressourcer',
    subtitle: 'Udforsk AllChinaBuy-regnearket, produktressourcer, sælgerguider, QC-information, forsendelsesguider og praktiske købstips på ét sted. Research smartere, før du bestiller.',
    ctaMain: 'Udforsk AllChinaBuy Spreadsheet',
    ctaSecondary: 'Start begynderguide',
    ctaAllChinaBuy: 'AllChinaBuy Spreadsheet',
    ctaBuyNow: 'Køb nu',
  },
  categories: {
    title: 'Populære kategorier',
    subtitle: 'Gennemse produktkategorier og find præcis, hvad du leder efter',
  },
  articles: {
    title: 'Seneste guides og ressourcer',
    subtitle: 'Original forskning, købstips og praktiske guides til at hjælpe dig med at handle smartere',
  },
  features: {
    title: 'Hvorfor bruge AllChinaBuy Spreadsheet?',
    item1: 'Organiserede produktlinks fra betroede sælgere',
    item2: 'QC-billeder og kvalitetsverifikationstips',
    item3: 'Forsendelsesomkostningsestimater og metodesammenligninger',
    item4: 'Aktive kupon- og rabatkodeopdateringer',
  },
  seo: {
    title: 'AllChinaBuy Spreadsheet 2026 — Produkter, Sælgere, QC & Forsendelse',
    description: 'Udforsk AllChinaBuy-regnearket, produktressourcer, sælgerguider, QC-information og forsendelsesguider på ét sted.',
    keywords: 'AllChinaBuy, regneark, købsguide, forsendelse, QC, kupon, rabat',
  },
};